import watchFetchCompanyGuestsSaga from '@/store/sagas/company/fetchCompanyGuests';

const sagas = [watchFetchCompanyGuestsSaga()];

export default sagas;
